import React from 'react';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="section cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Make Informed Decisions?</h2>
          <p className="cta-subtitle">
            Join thousands of students who are planning their future with clarity and confidence.
          </p>
          <div className="cta-buttons">
            <a href="https://12thplus.com/app/login" className="btn btn-primary">Get Started Free</a>
            <a href="/partner" className="btn btn-secondary">Partner With Us</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
